import { render, staticRenderFns } from "./TelstraUIVueUserHeader.vue?vue&type=template&id=975f0850"
import script from "./TelstraUIVueUserHeader.vue.ts?vue&type=script&lang=ts&external"
export * from "./TelstraUIVueUserHeader.vue.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports